
<template>
  <div class="record-info" v-if="recordInfo">
    <div class="record-status" v-if="recordInfo.status == '00'">
      <h1>待支付</h1>
      <p>您已提交咨询订单，请在{{timeStr}}内完成支付，超时未支付订单自动取消。</p>
    </div>
    <div class="record-status" v-if="recordInfo.status == '09'">
      <h1>支付超时</h1>
      <p>支付超时，请您请重新下单。</p>
    </div>
    <div class="record-status" v-if="recordInfo.status == '05' || recordInfo.status == '06' || recordInfo.status == '07' || recordInfo.status == '10'">
      <h1>已取消订单</h1>
      <p>已取消订单，请您请重新下单。</p>
    </div>
    <!-- <div class="record-status" v-if="recordInfo.status == '10'">
      <h1>已关闭</h1>
      <p>订单已关闭，请您请重新下单。</p>
    </div> -->
    <div class="record-doctor">
      <img src="../../assets/images/default_male.png">
      <div class="info">
        <h1>{{recordInfo.doctorName}}<span>{{recordInfo.doctorTitle}}</span></h1>
        <p>{{recordInfo.hospitalName}} | {{recordInfo.deptName}}</p>
      </div>
    </div>
    <div class="record-patient">
      <div class="title">
        <span>{{consultTypeObj1[recordInfo.consultType]}}</span>
        <i class="sp" v-if="recordInfo.consultType == '02' || recordInfo.consultType == '04'">视频</i>
        <i class="tw" v-else>图文</i>
      </div>
      <div class="main">
        <h1>{{recordInfo.userName}} {{recordInfo.userSex==1?'男':'女'}} {{recordInfo.userAge}}岁</h1>
        <p>病情：{{recordInfo.symptomDesc}}</p>
        <div class="imgs">
          <img :src="item" v-for="(item, index) in recordInfo.imgUrl" @click="showFullImg(item)" :key="index">
        </div>
      </div>
    </div>
    <div class="record-other">
      <div class="title">订单信息</div>
      <dl>
        <dt>订单类型</dt>
        <dd>{{consultTypeObj[recordInfo.consultType]}}</dd>
      </dl>
      <dl>
        <dt>订单号码</dt>
        <dd>{{orderNo}}</dd>
      </dl>
      <dl>
        <dt>下单时间</dt>
        <dd>{{recordInfo.createTime | dateFormat}}</dd>
      </dl>
      <dl>
        <dt>应付金额</dt>
        <dd class="blue">{{recordInfo.consultPrice}}</dd>
      </dl>
    </div>
    <div class="fixed-fill" v-if="recordInfo.status == '00'"></div>
    <div class="fixed-foot flex" v-if="recordInfo.status == '00'">
      <a class="cancel" @click="cancelOrder">取消订单</a>
      <a @click="goPay">去支付</a>
    </div>
    <!-- component -->
    <div class="images" v-viewer style="display: none;">
      <img v-for="src in images" :src="src" :key="src">
    </div>
  </div>
</template>
<script>
import * as $services from '@/services/index'
import { MessageBox } from 'mint-ui';
export default {
  filters: {
    dateFormat(date) {
      return date.substring(0,4)+"/"+date.substring(4,6)+"/"+date.substring(6,8)+"/ "+date.substring(8,10)+":"+date.substring(10,12)+":"+date.substring(12,14)
    }
  },
  data() {
    return {
      images: [],
      recordInfo:null,
      consultTypeObj1:{
        "01":"在线咨询",
        "02":"在线咨询",
        "03":"在线复诊",
        "04":"在线复诊",
        "05":"免费咨询",
        "06":"续方申请"
      },
      consultTypeObj:{
        "01":"在线咨询-图文咨询",
        "02":"在线咨询-视频咨询",
        "03":"在线复诊-图文咨询",
        "04":"在线复诊-视频咨询",
        "05":"免费咨询",
        "06":"续方申请"
      },
      isMini:false,
      cutTime:0,
      timeStr:"",
      timer:null
    };
  },
  created() {
    this.isMini = this.$store.getters.platform === 'mp'? true : false;
    this.orderNo = this.$route.query.orderNo;
    this.getConsultInfo();
  },
  mounted() {
    const ua = window.navigator.userAgent.toLowerCase();
  },
  methods: {
    cutTimer(){
      this.timer = setInterval(() => {
        this.cutTime --;
        this.timeFormat();
        if(this.cutTime <= 0){
          if(this.recordStatus == "03"){
            this.$store.dispatch('setRecordStatus', "08");
          }
          clearInterval(this.timer)
        }
      },1000)
    },
    timeFormat(){
      var hh = parseInt(this.cutTime / 3600);
      var mm = parseInt(this.cutTime / 60) % 60;
      var ss = this.cutTime % 60;
      this.timeStr = (hh>0?hh+"时":"")+(hh>0 || mm>0?mm+"分":"")+ss+"秒"
    },
    showFullImg (src) {
      // this.$store.dispatch('showFullscreenImg', {
      //   src
      // })
      this.images = [src]
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    },
    getConsultInfo(){
      $services.getConsultInfoByOrderNo({
        orderNo:this.orderNo,
        userType:"01"
      }).then(res => {
        console.log(res)
        this.recordInfo = res.record;
        this.recordInfo.imgUrl = this.recordInfo.imgUrl?this.recordInfo.imgUrl.split(","):[];
        this.cutTime = res.time;
        this.cutTimer();
      }).catch(function (err) {
        console.log(err);
      });
    },
    goPay(){
      var queryData = {
        money: this.recordInfo.consultPrice,
        consultType: this.recordInfo.consultType,
        orderNo: this.orderNo,
        type: 1
      }
      if (this.isMini === true) {
        queryData.payType = "03";
        queryData.sessionId = this.$store.getters.token;
        wx.miniProgram.navigateTo({
          url: "/pages/cashier/main?urlParam="+JSON.stringify(queryData)
        });
      }else{
        this.$router.push({ path: "/payment", query:queryData });
      }
    },
    cancelOrder(item){
      MessageBox.confirm('是否确认取消该订单?').then(action => {
          $services.sendInstructions({
            instructionsCode:"301002",
            doctorId:this.recordInfo.doctorId,
            url:""
          }).then(res => {
            this.recordInfo.status = "10"
          }).catch(err => {
            console.log(err);
          });
      }).catch(err => {
        console.log(err);
      });

    }
  },
  destroyed() {
    // this.$store.dispatch('hideFullscreenImg')
  }
};
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/recordInfo.vue